import { useStyles } from './style';

const PivotLayout: React.FC<{}> = ({ children }) => {
  const classes = useStyles();

  return <div className={classes.root}>{children}</div>;
};

export default PivotLayout;
